import { Role } from '../../../../../shared/enums/role.enum';
import { SecondarySideMenuI } from '../../../../../shared/interfaces/secondary-side-menu.interface';

export const SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'sideMenu.courses',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: (programID: string | number) => `programs/${programID}/courses`,
    alt: 'Courses',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.students',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: (programID: string | number) => `programs/${programID}/students`,
    alt: 'Students',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.plos',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: (programID: string | number) => `programs/${programID}/plos`,
    alt: 'PLOs',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.locs',
    activeIcon: 'svgs/side-menu/active-institutional-goals.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-institutional-goals.svg',
    route: (programID: string | number) => `programs/${programID}/competencies`,
    alt: 'Locs',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.evaluationCriterion',
    activeIcon: 'svgs/side-menu/active-evaluation-criterion.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-evaluation-criterion.svg',
    route: (programID: string | number) =>
      `programs/${programID}/evaluation-criteria`,
    alt: 'Evaluation Criteria',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
];
